const RENDER_MODE = {
  verticalSingleLeft: 'vertical-single-left',
  verticalSingleRight: 'vertical-single-right',
  verticalCrossed: 'vertical-crossed',
  horizontalSingle: 'horizontal-single',
  horizontalMultiple: 'horizontal-multiple'
}

const MODULE_NAME = 'MediaAndText'

const CHILD_EDITOR_NAME = `${MODULE_NAME}Item`
const CHILD_RENDER_NAME = `${MODULE_NAME}Item`

export {
  MODULE_NAME,
  CHILD_EDITOR_NAME,
  CHILD_RENDER_NAME,
  RENDER_MODE
}
